import { api } from './api';
import { isNativeApp, isNativeIOS } from './platform';

let pushListenersBound = false;

export async function registerPushNotifications(userId: string | undefined): Promise<void> {
  if (!isNativeApp() || !userId) return;

  try {
    const { PushNotifications } = await import('@capacitor/push-notifications');

    if (!pushListenersBound) {
      pushListenersBound = true;
      await PushNotifications.addListener('registration', async (token) => {
        const platform = isNativeIOS() ? 'ios' : 'android';
        await api('/api/push/register', {
          method: 'POST',
          body: JSON.stringify({ token: token.value, platform }),
        }).catch(() => undefined);
      });
    }

    const perm = await PushNotifications.requestPermissions();
    if (perm.receive !== 'granted') return;

    await PushNotifications.register();
  } catch {
    /* push not configured yet */
  }
}
